module.exports = __webpack_public_path__ + "static/media/magic-swirl.854dc419.svg";